<script setup>
import {
  computed,
  toRefs,
} from 'vue';
import { useI18n } from 'vue-i18n';
import PreviewFooter from '@/components/preview/kakao/common/PreviewFooter.vue';
import ImageComponent from '@/components/common/ImageComponent.vue';

const props = defineProps({
  introEnabled: {
    type: Boolean,
    default: false,
  },
  header: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  imageUrl: {
    type: String,
    default: '',
  },
  position: {
    type: String,
    default: '',
  },
  index: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();

const {
  position,
  index,
  header,
  content,
} = toRefs(props);

const itemHoverClass = computed(() => {
  if (position.value === `carousel-commerce-${index.value}`) {
    return 'editAreaPositionHover';
  }

  return '';
});

const imageHoverClass = computed(() => {
  if (position.value === `carousel-commerce-${index.value}-image`) {
    return 'editAreaPositionHover';
  }

  return '';
});

const titleHoverClass = computed(() => {
  if (position.value === `carousel-commerce-${index.value}-header`) {
    return 'editAreaPositionHover';
  }

  return '';
});

const contentHoverClass = computed(() => {
  if (position.value === `carousel-commerce-${index.value}-content`) {
    return 'editAreaPositionHover';
  }

  return '';
});

const displayTitle = computed(() => header.value || t('kakaoBasic.preview.introTitle'));
const displayContent = computed(() => content.value || t('kakaoBasic.preview.introContent'));

defineOptions({
  inheritAttrs: false,
});

</script>
<template>
  <li
    class="swiper-slide"
    :class="itemHoverClass"
  >
    <div class="preview-message__container">
      <div
        class="preview-message__content-container"
        :class="{ blur: !introEnabled }"
      >
        <div class="preview-message__content">
          <div
            class="preview-message__inner-img"
            :class="imageHoverClass"
          >
            <ImageComponent
              :src="imageUrl"
              :alt="`carousel-image${index}`"
            />
          </div>
          <div class="preview-message__inner">
            <div>
              <h5
                class="carousel-feed__title carousel-commerce__title--intro"
                :class="titleHoverClass"
              >
                {{ displayTitle }}
              </h5>
              <div class="carousel-commerce__line"></div>
              <div
                class="carousel-feed__desc carousel-commerce__desc--intro"
                :class="contentHoverClass"
              >
                {{ displayContent }}
              </div>
            </div>
          </div>
          <PreviewFooter />
        </div>
      </div>
      <div
        class="preview-message__intro-placeholder"
        :class="{ 'd-none': introEnabled }"
      >
        <div>
          {{ t('kakaoBasic.preview.intro') }}
        </div>
      </div>
    </div>
  </li>
</template>
<style>
</style>
